const url = "http://localhost:4200"
const urlApi = "https://my.imzaflow.com"
const urlLoginServer = "https://my.imzaflow.com"

const basepath = "/login-page";
const urlLogin = urlLoginServer + basepath;

export const environment = {
    production: false,
    basepath: basepath,
    appUrl: url,
    apiUrl: urlApi + '/api',
    loginUrl: urlLogin,
    editUrl: urlLogin + '/edit-profile',
    twoFactorUrl: urlLogin + '/edit-2fa-settings',
    fileServer: 'https://dav.imzaflow.de',
    globalProcessId: '4f70b9f0-95bb-4840-950b-db73448911a3',
    globalLanguages: [] = ['en', 'de', 'tr'],
    groupsUrl: urlLogin + '/permission-groups',
    signatureCheckFirm: 'Imzaflow',
    stripeKey: 'pk_live_51RvEPZDDL4kNOlHQJbVKAAxxAOK5H37mLeYXIDEE3MkZfAKyEv43KsRDPqKribRDXRD5ylGRey8T4D3XexJwp2qb00cyDyh5Kd',
    //stripeKey: 'pk_test_51RvEPZDDL4kNOlHQpWD2sjxfSYmTwmGkAdXGKoyruYWkkzsBNzWYj9EUDU3DccY9vA1JNHCAGBpJlFLHwCXKwbZo00tFHhRhKX',

    fesPrice: 1.80,
    qesPrice: 3.80,

    domain: "leer",
    name: "leer",
    onpremise: true
};
